import React, { Component, Fragment } from 'react';
import { inject, observer } from 'mobx-react';
import { CarsQueueIcon } from '../../../../../common/icons';

import './AddToGroup.css';

@inject('translationsStore')
@observer
export default class AddToGroup extends Component
{
  render() {
    const { visible, translationsStore, onChooseGroup } = this.props;
    return <Fragment>
      { !!visible &&
        <div className="AddToGroup" onClick={onChooseGroup}>
          <div><CarsQueueIcon width="30px" height="20px" /></div>
          <div>{ translationsStore.translate('groupsManager.assignToGroup.buttonLabel') }</div>
        </div>
      }
    </Fragment>
  }
}



// WEBPACK FOOTER //
// ./src/components/App/GroupsManagerDashboard/ClientsWithGroups/AddToGroup/AddToGroup.js